<template>
  <section id="thankYou" v-bind:class="{ 'animate-thank-you': animateThankYou, fontLoaded }">
    <div class="swpoll-thankyou-msg">
      <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-257.000000, -284.000000)" stroke="#AEC14D" stroke-width="1.8">
                  <g id="Group" transform="translate(258.000000, 285.000000)">
                      <circle id="Oval" cx="10" cy="10" r="10"></circle>
                      <polyline id="Path" stroke-linecap="round" stroke-linejoin="round" points="6.42521741 9.48717949 9.23076923 12.2927313 13.4292733 8.09422721"></polyline>
                  </g>
              </g>
          </g>
      </svg>
      <p>{{thankYouMessage}}</p>
    </div>
  </section>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
export default {
  name: 'ThankYou',
  data() {
    return {
      animateThankYou: false
    };
  },
  computed: {
    ...mapState('poll', ['fontLoaded']),
    ...mapGetters('poll', ['thankYouMessage'])
  },
  mounted() {
    setTimeout(() => {
      this.animateThankYou = true;
    }, 300);
  }
};
</script>

<style scoped lang="scss">
section {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 25px;
  background-color: var(--success-color);
  color: var(--white);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(.2);
  opacity: 0;
  animation: pop cubic-bezier(0.175, 0.885, 0.320, 1.275) .5s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  animation-fill-mode: forwards;
  white-space: nowrap;
}

.swpoll-thankyou-msg {
  display: flex;
  align-items: center;
  transition: .5s ease-out;
  animation: fadepop cubic-bezier(0.175, 0.885, 0.320, 1.275) .5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  p {
    margin: 0;
    font-size: 1.1rem;
    opacity: 0;
  }

  svg {
    margin: 0 auto;
    display: block;
    transition: all 700ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
    width: 20px;
    height: 20px;
    margin-right: 10px;
    transform: scale(.4);
    opacity: 0;

    circle,
    polyline {
      stroke: var(--white);
    }
  }
}

.animate-thank-you {

  .swpoll-thankyou-msg {

    svg {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.fontLoaded {

  p {
    opacity: 1;
  }
}

.isHorizontal {
  section {
    display: inline-flex;
    margin-bottom: 12px;
  }
}

.style-bbl,
.style-veev {

  section {
    width: calc(100% - 60px);
    transform: none;
  }

  svg {
    display: none;
  }

  p {
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
  }

  @media screen and (max-width: 768px) {
    section {
      width: calc(100% - 40px);
      padding: 5px;
      margin-top: 25px;
      border-radius: 10px;

      p {
        font-size: 10px;
        padding-top: 0px;
        padding-bottom: 0px;
      }
    }
  }
}
</style>
